<template>
    <div class="tab-content" v-show="title == selectedTab">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "Tab"
    }
</script>

<script setup>
    import { inject } from 'vue';
    const props = defineProps({ 'title': String });
    const selectedTab = inject('selectedTab');
</script>
